
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Manubar from "./Manubar";
import Security from "./Security";
import Footer from "./Footer";
import axios from "axios";
import "./loader.css";
import "./Aboutus.css"; // About Us / Terms wali responsive CSS yahan bhi use hogi

/* Heading rules:
   1) Jis line ke aage "## " ho wo hamesha heading
   2) Warna: "1. Definitions" jaisi chhoti numbered line
      ya ":" par khatam hone wali chhoti line */
const isHeading = (line) => {
  const text = line.trim();
  if (!text) return false;
  if (text.startsWith("## ")) return true;
  if (text.length > 90) return false;
  return /^\d+\.\s+\S/.test(text) || /:$/.test(text);
};

/* Markdown link [text](url) ko sirf text bana do */
const cleanLine = (line) =>
  line.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, "$1").trim();

/* "## " dikhane se pehle hata do */
const headingText = (line) => line.replace(/^##\s+/, "");

const RenderDescription = ({ text }) => {
  const lines = String(text || "")
    .split(/\r?\n/)
    .map(cleanLine)
    .filter((line) => line !== "");

  return lines.map((line, i) =>
    isHeading(line) ? (
      <h3 key={i} className="aboutus-subheading">
        {headingText(line)}
      </h3>
    ) : (
      <p key={i} className="aboutus-text text-start">
        {line}
      </p>
    )
  );
};

const PrivacyAndPolicy = () => {

  const [privacy, setPrivacy] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getPrivacy() {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API}website/privacy_policy`
      );

      setPrivacy(res?.data?.data || []);
      setLoading(false); // API load hone par loader band
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getPrivacy();
  }, []);

  return (
    <div className="aboutus-page">

      {/* Mobile Menu */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center flex-wrap">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  Privacy & Policy
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Content Section */}
      <section className="about-section section-mt section-mb">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-12 col-xl-10">

              <div className="about-content aboutus-content">

                {/* Loader */}
                {loading ? (

                  <div className="aboutus-loader-wrap">
                    <div className="loader"></div>
                  </div>

                ) : privacy.length === 0 ? (

                  <p className="aboutus-empty">
                    No information available right now.
                  </p>

                ) : (

                  privacy.map((item, idx) => (
                    <div key={idx} className="aboutus-block">
                      <h2 className="title aboutus-title">
                        {item?.title}
                      </h2>

                      <RenderDescription text={item?.description} />
                    </div>
                  ))

                )}

              </div>

            </div>

          </div>
        </div>
      </section>

      <Security />
      <Footer />

    </div>
  );
};

export default PrivacyAndPolicy;